import { useDispatch, useSelector } from 'react-redux';
import {
  deleteFromAllInvitationSourcesSelector,
  deleteInvitationSourceMappings,
  invitationSourceMappingsToDeleteSelector,
  isDeleteInvitationSourceMappingsPanelOpenSelector,
  isDeletingInvitationSourceMappingsSelector,
  setIsDeleteInvitationSourceMappingsPanelOpen,
} from '../../../../../../../../features/pageFeatures/createHearingPageSlice';

export const useDeleteInvitationSourceMappings = (hearingId) => {
  const dispatch = useDispatch();

  const isPopupOpen = useSelector(
    isDeleteInvitationSourceMappingsPanelOpenSelector,
  );
  const isUpdating = useSelector(isDeletingInvitationSourceMappingsSelector);
  const deleteFromAllInvitationSources = useSelector(
    deleteFromAllInvitationSourcesSelector,
  );
  const invitationSourceMappingIds = useSelector(
    invitationSourceMappingsToDeleteSelector,
  );

  function setIsPopupOpen() {
    dispatch(setIsDeleteInvitationSourceMappingsPanelOpen(false));
  }

  function onConfirm() {
    dispatch(
      deleteInvitationSourceMappings({
        hearingId,
        invitationSourceMappingIds,
        deleteFromAllInvitationSources,
      }),
    );
  }

  return {
    isPopupOpen,
    isUpdating,
    deleteFromAllInvitationSources,
    setIsPopupOpen,
    onConfirm,
  };
};
